export const coro = {
  purple: '#3D0A5E',
  purpleish: '#DC99EE',
  gray: '#4a5b6c',
  red: "#ae132a",
  darkred: "#a5333a",
  brown: "#43050e",
  lightgray: "#f6f6f8",
  lightgray2: "#e4e9f2",
  yellow: "#ffc94d",
  blue: "#006fd6",
  lightblue: "#f2f8ff",
  green: "#00b383",
  lightgreen: "#edfff3",
  white: "#FFFFFF",
  recommendationClass: {
    I: "#66DD9C",
    IIa: "yellow",
    IIb: "#f3ae3d",
    III: "#eb4f73",
    A: "#4192f7",
    B: "#8CC8FC",
    C: "#F3F8FE"
  },
  "primary-100": "#FDF8FF",
  "primary-200": "#DC99EE",
  "primary-300": "#B05FCE",
  "primary-400": "#7A349E",
  "primary-500": "#3D0A5E",
  "primary-600": "#2F0750",
  "primary-700": "#230543",
  "primary-800": "#190336",
  "primary-900": "#11012D",
  "primary-transparent-100": "rgba(61, 10, 94, 0.08)",
  "primary-transparent-200": "rgba(61, 10, 94, 0.16)",
  "primary-transparent-300": "rgba(61, 10, 94, 0.24)",
  "primary-transparent-400": "rgba(61, 10, 94, 0.32)",
  "primary-transparent-500": "rgba(61, 10, 94, 0.4)",
  "primary-transparent-600": "rgba(61, 10, 94, 0.48)",
  "success-100": "#F0FEF4",
  "success-200": "#C3FDD9",
  "success-300": "#A7F7CA",
  "success-400": "#82ECB5",
  "success-500": "#66DD9C",
  "success-600": "#4ABE8A",
  "success-700": "#339F79",
  "success-800": "#208068",
  "success-900": "#136A5D",
  "success-transparent-100": "rgba(102, 221, 156, 0.08)",
  "success-transparent-200": "rgba(102, 221, 156, 0.16)",
  "success-transparent-300": "rgba(102, 221, 156, 0.24)",
  "success-transparent-400": "rgba(102, 221, 156, 0.32)",
  "success-transparent-500": "rgba(102, 221, 156, 0.4)",
  "success-transparent-600": "rgba(102, 221, 156, 0.48)",
  "info-100": "#F3F8FE",
  "info-200": "#B3DEFE",
  "info-300": "#8CC8FC",
  "info-400": "#6FB3FA",
  "info-500": "#4192f7",
  "info-600": "#2F71D4",
  "info-700": "#2054B1",
  "info-800": "#143A8F",
  "info-900": "#0C2876",
  "info-transparent-100": "rgba(65, 146, 247, 0.08)",
  "info-transparent-200": "rgba(65, 146, 247, 0.16)",
  "info-transparent-300": "rgba(65, 146, 247, 0.24)",
  "info-transparent-400": "rgba(65, 146, 247, 0.32)",
  "info-transparent-500": "rgba(65, 146, 247, 0.4)",
  "info-transparent-600": "rgba(65, 146, 247, 0.48)",
  "warning-100": "#FEFAE2",
  "warning-200": "#FDE9B1",
  "warning-300": "#FBD98A",
  "warning-400": "#F7C86C",
  "warning-500": "#f3ae3d",
  "warning-600": "#D08C2C",
  "warning-700": "#AE6D1E",
  "warning-800": "#8C5013",
  "warning-900": "#743C0B",
  "warning-transparent-100": "rgba(243, 174, 61, 0.08)",
  "warning-transparent-200": "rgba(243, 174, 61, 0.16)",
  "warning-transparent-300": "rgba(243, 174, 61, 0.24)",
  "warning-transparent-400": "rgba(243, 174, 61, 0.32)",
  "warning-transparent-500": "rgba(243, 174, 61, 0.4)",
  "warning-transparent-600": "rgba(243, 174, 61, 0.48)",
  "danger-100": "#FDF3F3",
  "danger-200": "#FDBDB9",
  "danger-300": "#F99599",
  "danger-400": "#F37A8A",
  "danger-500": "#eb4f73",
  "danger-600": "#CA3968",
  "danger-700": "#A9275E",
  "danger-800": "#881952",
  "danger-900": "#700F4B",
  "danger-transparent-100": "rgba(235, 79, 115, 0.08)",
  "danger-transparent-200": "rgba(235, 79, 115, 0.16)",
  "danger-transparent-300": "rgba(235, 79, 115, 0.24)",
  "danger-transparent-400": "rgba(235, 79, 115, 0.32)",
  "danger-transparent-500": "rgba(235, 79, 115, 0.4)",
  "danger-transparent-600": "rgba(235, 79, 115, 0.48)",
  "status-darkred": "#a5333a",
  "status-red": "rgba(244, 67, 54, 0.9)",
  "status-orange": "rgba(255, 152, 0, 0.9)",
  "status-yellow": "rgba(255, 201, 77, 0.9)",
  "status-green": "rgba(76, 175, 80, 0.9)",
}

export const colors = {
  coro: coro
}
